import './AFED.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class AFED extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
